import { apiClient } from './client'
import type {
  HistoryApplyResult,
  HistoryCustomer,
  HistoryCustomerSummary,
  HistoryPreview,
  HistoryState,
  HistoryUploadResult,
  HistoryWorklistEntry
} from './types'

export interface HistoryRunPayload {
  entry: HistoryWorklistEntry
  enablePostnord: boolean
  enableBilling: boolean
}

export interface HistoryStatePayload {
  state: Exclude<HistoryState, 'applied'>
  note?: string | null
}

export async function uploadWorklist(worklist: unknown): Promise<HistoryUploadResult> {
  const { data } = await apiClient.post<HistoryUploadResult>('/history/worklist', worklist)

  return data
}

export async function listHistoryCustomers(signal?: AbortSignal): Promise<HistoryCustomerSummary[]> {
  const { data } = await apiClient.get<unknown>('/history/customers', { signal })

  return Array.isArray(data) ? (data as HistoryCustomerSummary[]) : []
}

export async function getHistoryCustomer(customerId: number): Promise<HistoryCustomer> {
  const { data } = await apiClient.get<HistoryCustomer>(`/history/customers/${customerId}`)

  return data
}

export async function previewHistory(customerId: number, payload: HistoryRunPayload): Promise<HistoryPreview> {
  const { data } = await apiClient.post<HistoryPreview>(`/history/customers/${customerId}/preview`, payload)

  return data
}

export async function applyHistory(customerId: number, payload: HistoryRunPayload): Promise<HistoryApplyResult> {
  const { data } = await apiClient.post<HistoryApplyResult>(`/history/customers/${customerId}/apply`, payload)

  return data
}

export async function setHistoryState(customerId: number, payload: HistoryStatePayload): Promise<HistoryCustomer> {
  const { data } = await apiClient.patch<HistoryCustomer>(`/history/customers/${customerId}/state`, payload)

  return data
}

export async function revertHistoryEntry(entryId: number): Promise<HistoryCustomer> {
  const { data } = await apiClient.post<HistoryCustomer>(`/history/entries/${entryId}/revert`)

  return data
}
